import { useState } from 'react';
import Mosaic, { MoreItemsButton } from 'components/3catinfo/Mosaic';
import Autor from 'components/3catinfo/Autor';
import __isEmpty from 'lodash/isEmpty';
import styles from './llistatfirmes.module.scss';

const LlistatFirmes = (props) => {
    const { titol, items, enviaApi, className, numColumns, estilMosaic, estilAutor, originUsuaris } = props;
    const [itemsDinamics, setItemsDinamics] = useState([]);

    const options = {
        numColumns,
        estilMosaic,
        className
    };

    return items ? (
        <div>
            <Mosaic titol={titol} {...options}>
                {[...items, ...itemsDinamics].map((item, i) => {
                    const itemId = item.id ?? i;
                    return (
                        <Autor
                            key={`llistatfirmes-${itemId}`}
                            item={item}
                            mostrarCarrec={true}
                            mostrarSegueix={true}
                            estil={estilAutor}
                            enviaApi={enviaApi}
                            originUsuaris={originUsuaris}
                        />
                    );
                })}
            </Mosaic>
            <MoreItemsButton
                {...props}
                className={styles.botoPaginacio}
                numItems={items.length}
                setItemsDinamics={(newItems) => setItemsDinamics([...itemsDinamics, ...newItems])}
            />
        </div>
    ) : (
        <></>
    );
};

LlistatFirmes.defaultProps = {
    enviaApi: true,
    numColumns: 3,
    estilMosaic: 'firmes',
    estilAutor: 'mosaic'
};

export default LlistatFirmes;
